import Province from './Province';

export default {
    list: Province,
};
